import { PageHeading, UserRoleHeading } from "@/components/Layout/Parts";
import DeletedInvoicesTable from "./components/DeletedInvoicesTable";

const DeletedInvoicesList = () => {
  return (
    <>
      <UserRoleHeading />
      <PageHeading>Deleted List</PageHeading>
      <DeletedInvoicesTable />
    </>
  );
};

export default DeletedInvoicesList;
